import { Fragment } from "react";

import { TextOnlyButtonProps } from "./types";

const TextOnlyButton = ({ title }: TextOnlyButtonProps) => {
    return <Fragment>{title}</Fragment>;
};

export default TextOnlyButton;
